<template>
  <!-- 筛选时间舱位等（只限于自由组合） -->
  <div v-if="getTabName == 'second'" class="fc_aside_wrap">
    <div class="aside_title">
      <span class="select">筛选</span>
      <span class="clean" @click="cleanAll()">全部清除</span>
    </div>
    <div class="aside_main">
      <div v-for="(item, i) in filterListData" :key="i" class="checkbox_wrap">
        <div class="top_wrap">
          <span class="title">{{ item.fieldTitle }}</span>
          <span class="limit" @click="clean(i)">不限</span>
        </div>
        <ul>
          <li
            v-for="(item2, j) in item.options"
            :key="j"
            class="checkbox_li"
            :class="{ checkbox_li_active: item2.checked }"
            @click="chose(i, j)"
          >
            {{ item2.optionTitle }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script >
import filter from "../../utils/filter";
export default {
  name: "selecteda",
  data() {
    return {
      filterListData: [],
      isFirstLoad: true,
    };
  },
  methods: {
    chose: function (i, j) {
      this.filterListData[i].options[j].checked =
        !this.filterListData[i].options[j].checked;
    },
    clean: function (index) {
      let filters = this.filterListData;
      let cleanFilter = filters[index];
      cleanFilter.options.map((item) => {
        item.checked = false;
      });
    },
    cleanAll: function () {
      let filters = this.filterListData;
      filters.map((item) => {
        item.options.map((item2) => {
          item2.checked = false;
        });
      });
    },
    buildAside() {
      let tabName = this.$store.getters.getTabName;
      let filterList = [];
      if (tabName == "first") {
      } else {
        //自由组合
        let flightData = this.$store.getters.getFreeFlight;
        let filters = new filter(tabName, flightData);
        filterList = filters.getFilter();
      }
      return filterList;
    },
  },
  updated: function () {},
  mounted: function () {},
  watch: {
    //推荐组合  自助游
    "$store.getters.recommendFlight"(val, oldVal) {
      let filterList = this.$options.methods.buildAside.bind(this)();
      filterList.forEach((item, index) => {
        item.options.forEach((smItem, smIndex) => {
          smItem.checked = false;
        });
      });
      this.filterListData = filterList;
      return filterList;
    },
    "$store.getters.getFreeFlight": {
      handler(val, oldVal) {
        let filterList = this.$options.methods.buildAside.bind(this)();
        filterList.forEach((item, index) => {
          item.options.forEach((smItem, smIndex) => {
            smItem.checked = false;
          });
        });
        this.filterListData = filterList;
        return filterList;
      },
      immediate: true,
      deep: true,
    },
    filterListData: {
      handler() {
        let tabName = this.$store.getters.getTabName;
        if (tabName == "second") {
          this.$store.commit("setFilter", this.filterListData);
        }
      },
      deep: true,
    },
  },
  computed: {
    getTabName() {
      return "second";
      // return this.$store.getters.getTabName;
    },
  },
};
</script>
<style scoped lang="scss">
.fc_aside_wrap {
  font-size: 12px;
  color: #333;
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 10px;
  .aside_title {
    .select {
      font-size: 18px;
      color: #666666;
    }
    .clean {
      float: right;
      border: 1px solid #eeeeee;
      padding: 3px 6px;
      cursor: pointer;
    }
  }
  .aside_main {
    border: 1px solid #eeeeee;
    border-bottom: none;
    margin-top: 6px;
    height: 390px;
    overflow-y: auto;
    .checkbox_wrap {
      padding: 15px;
      border-bottom: 1px solid #eeeeee;
      .top_wrap {
        padding-bottom: 15px;
        .title {
          font-size: 14px;
        }
        .limit {
          float: right;
          color: #999;
          cursor: pointer;
        }
      }
      ul {
        list-style: none;
      }
      .checkbox_li {
        overflow: visible;
        margin-bottom: 10px;
        cursor: pointer;
        list-style-type: none;
        display: list-item;
        text-align: -webkit-match-parent;
      }
      .checkbox_li_active {
        color: #ff8800;
      }
      .checkbox_li:before {
        content: "\2714";
        color: #fff;
        padding: 0px 3px;
        border: solid 1px #ddd;
        cursor: pointer;
      }
      .checkbox_li_active:before {
        color: #ff8800;
        border: solid 1px #ff8800;
      }
    }
  }
}
</style>
